module.exports = __webpack_public_path__ + "media/discord.303a9497.mp3";